import { render, staticRenderFns } from "./SummaryMatrix.vue?vue&type=template&id=06319b68&scoped=true&"
import script from "./SummaryMatrix.vue?vue&type=script&lang=js&"
export * from "./SummaryMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMatrix.vue?vue&type=style&index=0&id=06319b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06319b68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
